import { render, staticRenderFns } from "./SendInviteModal.vue?vue&type=template&id=25048088&"
import script from "./SendInviteModal.vue?vue&type=script&lang=ts&"
export * from "./SendInviteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports